import { render, staticRenderFns } from "./Global-Modal.vue?vue&type=template&id=700ae7b7&scoped=true&"
import script from "./Global-Modal.vue?vue&type=script&lang=js&"
export * from "./Global-Modal.vue?vue&type=script&lang=js&"
import style0 from "./Global-Modal.vue?vue&type=style&index=0&id=700ae7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ae7b7",
  null
  
)

export default component.exports